import axios from 'axios';

const BorrowerService = {
  async createBorrower(formValues) {
    const response = await axios.post('/borrowers', formValues);

    return response.data;
  },

  async getBorrower(id) {
    const response = await axios.get(`/borrowers/${id}`);

    return response.data;
  },

  async getBorrowersOfLoanFile(loanFileId) {
    const response = await axios.get(`/loan-files/${loanFileId}/borrowers`);

    return response.data;
  },

  async updateBorrower({ formValues, id }) {
    const response = await axios.patch(`/borrowers/${id}`, formValues);

    return response.data;
  },

  async deleteBorrower(id) {
    const response = await axios.delete(`/borrowers/${id}`);

    return response.data;
  },

  async createOrUpdateBorrowerCreditReport({ formValues, id }) {
    const response = await axios.put(
      `/borrowers/${id}/credit-reports`,
      formValues
    );

    return response.data;
  },
};

export default BorrowerService;
